<script>
import axios from '@/utils/axios';

const DEFAULT_FORM = () => ({
  id: null,
  name: '',
  description: '',
});

export default {
  inject: ['setLoading'],
  emits: ['updated'],
  data() {
    return {
      form: DEFAULT_FORM(),
      errors: {},
      deleteItem: null,
    };
  },
  methods: {
    add() {
      this.resetForm();
    },

    edit(item) {
      this.resetForm();
      this.form.id = item.id;
      this.form.name = item.name || '';
      this.form.description = item.description || '';
    },

    setDelete(item) {
      this.deleteItem = item;
    },

    buildPayload() {
      return {
        name: this.form.name,
        description: this.form.description || null,
      };
    },

    async save() {
      this.errors = {};
      this.setLoading(true);
      try {
        let response;
        if (this.form.id) {
          response = await axios.put(`/hrms/salary-structures/${this.form.id}`, this.buildPayload());
        } else {
          response = await axios.post('/hrms/salary-structures', this.buildPayload());
        }
        this.$swalToast(response.data.message);
        this.$emit('updated');
        this.$closeModal('hrm_salary_structure_modal');
        this.resetForm();
      } catch (error) {
        if (error.type === 'validation') {
          this.errors = error.errors;
        } else {
          this.$swalToast(error.message, 'error');
        }
      } finally {
        this.setLoading(false);
      }
    },

    async deleteStructure() {
      this.setLoading(true);
      try {
        const response = await axios.delete(`/hrms/salary-structures/${this.deleteItem.id}`);
        this.$swalToast(response.data.message);
        this.$emit('updated');
        this.$closeModal('hrm_salary_structure_delete_modal');
      } catch (error) {
        if (error.type === 'validation') {
          this.$swalToast(error.errors?.id?.[0] || error.message, 'error');
        } else {
          this.$swalToast(error.message, 'error');
        }
      } finally {
        this.setLoading(false);
      }
    },

    resetForm() {
      this.form = DEFAULT_FORM();
      this.errors = {};
    },
  },
};
</script>

<template>
  <!-- Add/Edit Modal -->
  <div class="modal fade" id="hrm_salary_structure_modal">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">{{ form.id ? 'Edit' : 'Add' }} Salary Structure</h4>
          <button type="button" class="btn-close custom-btn-close" data-bs-dismiss="modal" aria-label="Close">
            <i class="ti ti-x"></i>
          </button>
        </div>
        <form @submit.prevent="save">
          <div class="modal-body pb-0">

            <!-- Name -->
            <div class="mb-3">
              <label class="form-label">Name <span class="text-danger">*</span></label>
              <input type="text" class="form-control" v-model="form.name" placeholder="e.g. Senior" />
              <div v-if="errors.name" class="text-danger small mt-1">{{ errors.name[0] }}</div>
            </div>

            <!-- Description -->
            <div class="mb-3">
              <label class="form-label">Description</label>
              <textarea class="form-control" rows="3" v-model="form.description" placeholder="Enter description (optional)"></textarea>
              <div v-if="errors.description" class="text-danger small mt-1">{{ errors.description[0] }}</div>
            </div>

          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-light me-2" data-bs-dismiss="modal">Cancel</button>
            <button type="submit" class="btn btn-primary">{{ form.id ? 'Update' : 'Save' }}</button>
          </div>
        </form>
      </div>
    </div>
  </div>

  <!-- Delete Modal -->
  <div class="modal fade" id="hrm_salary_structure_delete_modal">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body text-center">
          <span class="avatar avatar-xl bg-transparent-danger text-danger mb-3">
            <i class="ti ti-trash-x fs-36"></i>
          </span>
          <h4 class="mb-1">Confirm Delete</h4>
          <p class="mb-3">You want to delete this salary structure? This can't be undone.</p>
          <div class="d-flex justify-content-center">
            <a href="javascript:void(0);" class="btn btn-light me-3" data-bs-dismiss="modal">Cancel</a>
            <a href="javascript:void(0);" class="btn btn-danger" @click="deleteStructure">Yes, Delete</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>